import { useEffect } from "react";
import { datadogRum } from "@datadog/browser-rum";

export const normalizeViewName = (name: string): string => {
    if (/^\/stays\/shop\/.+\/customize$/.test(name)) return "stays_shop_cfar";
    if (/^\/stays\/shop(\/.*)?$/.test(name)) return "stays_shop";
    if (/^\/stays\/availability(\/.*)?$/.test(name)) return "stays_availability";
    return name;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- RUM event type is not exported by @datadog/browser-rum at this version
export const datadogBeforeSend = (event: any): boolean => {
    // Drop Google Maps resource events to reduce noise
    if (event.type === "resource") {
        const url = event.resource.url;
        if (
            url.includes("maps.googleapis.com") ||
            url.includes("maps.gstatic.com") ||
            url.includes("khms")
        ) {
            return false;
        }
    }

    try {
        if (event.view && event.view.url) {
            const urlPath = new URL(event.view.url).pathname;
            const normalized = normalizeViewName(urlPath);
            if (normalized !== urlPath) {
                // eslint-disable-next-line no-param-reassign
                event.view.name = normalized;
            }
        }
    } catch {
        // noop — invalid URL, skip normalization
    }
    return true;
};

export const useDatadogExperimentsContext = (
    experiments: { id: string; variant: string }[] | undefined
) => {
    useEffect(() => {
        if (experiments != null && experiments.length > 0) {
            datadogRum.setGlobalContextProperty(
                "experiments",
                experiments.map((ex) => `${ex.id}_${ex.variant}`)
            );
        }
    }, [experiments]);
};
